/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Demo_ReplyInputs */

const en_mcp_demo_reply = /** @type {(inputs: Mcp_Demo_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent to Listening. The audio is ready in your library.`)
};

const es_mcp_demo_reply = /** @type {(inputs: Mcp_Demo_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviado a Listening. El audio ya está listo en tu biblioteca.`)
};

/**
* | output |
* | --- |
* | "Sent to Listening. The audio is ready in your library." |
*
* @param {Mcp_Demo_ReplyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_demo_reply = /** @type {((inputs?: Mcp_Demo_ReplyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Demo_ReplyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_demo_reply(inputs)
	return en_mcp_demo_reply(inputs)
});